<!-- SignUp Page -->
<section class="signup-body">
    <!-- <div class="logo"></div> -->
    <div class="signup-div">
    <div class="title">Create account</div>
   <!---- <div class="sub-title">Create account</div>-->
    <div class="fields">
    <form [formGroup]="signUpFormGroup" class= "example-form" (ngSubmit)="onSubmit()" >
    <div class="firstName" >
    <svg class="svg-icon" viewBox="0 0 20 20">
    <path d="M15.573,11.624c0.568-0.478,0.947-1.219,0.947-2.019c0-1.37-1.108-2.569-2.371-2.569s-2.371,1.2-2.371,2.569c0,0.8,0.379,1.542,0.946,2.019c-0.253,0.089-0.496,0.2-0.728,0.332c-0.743-0.898-1.745-1.573-2.891-1.911c0.877-0.61,1.486-1.666,1.486-2.812c0-1.79-1.479-3.359-3.162-3.359S4.269,5.443,4.269,7.233c0,1.146,0.608,2.202,1.486,2.812c-2.454,0.725-4.252,2.998-4.252,5.685c0,0.218,0.178,0.396,0.395,0.396h16.203c0.218,0,0.396-0.178,0.396-0.396C18.497,13.831,17.273,12.216,15.573,11.624 M12.568,9.605c0-0.822,0.689-1.779,1.581-1.779s1.58,0.957,1.58,1.779s-0.688,1.779-1.58,1.779S12.568,10.427,12.568,9.605 M5.06,7.233c0-1.213,1.014-2.569,2.371-2.569c1.358,0,2.371,1.355,2.371,2.569S8.789,9.802,7.431,9.802C6.073,9.802,5.06,8.447,5.06,7.233 M2.309,15.335c0.202-2.649,2.423-4.742,5.122-4.742s4.921,2.093,5.122,4.742H2.309z M13.346,15.335c-0.067-0.997-0.382-1.928-0.882-2.732c0.502-0.271,1.075-0.429,1.686-0.429c1.828,0,3.338,1.385,3.535,3.161H13.346z"></path>
    </svg>
    <mat-form-field>
            <mat-label>Company name</mat-label>
    <input matInput  formControlName="firstName" class="firstName-input" required>
    <mat-error
    *ngIf="signUpFormGroup.controls.firstName.invalid && (signUpFormGroup.controls.firstName.dirty || signUpFormGroup.controls.firstName.touched)" required>
    {{getErrorMsgForAddFeedbackFormfirstName()}}
    </mat-error>
</mat-form-field>
    </div>
    <div class="lastName">
    <svg class="svg-icon" viewBox="0 0 20 20">
    <path d="M12.075,10.812c1.358-0.853,2.242-2.507,2.242-4.037c0-2.181-1.795-4.618-4.198-4.618S5.921,4.594,5.921,6.775c0,1.53,0.884,3.185,2.242,4.037c-3.222,0.865-5.6,3.807-5.6,7.298c0,0.23,0.189,0.42,0.42,0.42h14.273c0.23,0,0.42-0.189,0.42-0.42C17.676,14.619,15.297,11.677,12.075,10.812 M6.761,6.775c0-2.162,1.773-3.778,3.358-3.778s3.359,1.616,3.359,3.778c0,2.162-1.774,3.778-3.359,3.778S6.761,8.937,6.761,6.775 M3.415,17.69c0.218-3.51,3.142-6.297,6.704-6.297c3.562,0,6.486,2.787,6.705,6.297H3.415z"></path>
    </svg>
    <mat-form-field>
            <mat-label>User name</mat-label>
    <input matInput  formControlName="lastName" class="lastName-input" required>
    <mat-error
    *ngIf="signUpFormGroup.controls.lastName.invalid && (signUpFormGroup.controls.lastName.dirty || signUpFormGroup.controls.lastName.touched) || signUpFormGroup.get('lastName').errors?.whitespace">
    {{getErrorMsgForAddFeedbackFormlastName()}}
    </mat-error>
    </mat-form-field>
    </div>
    <div class="email">
    <svg class="svg-icon" viewBox="0 0 20 20">
    <path d="M17.388,4.751H2.613c-0.213,0-0.389,0.175-0.389,0.389v9.72c0,0.216,0.175,0.389,0.389,0.389h14.775c0.214,0,0.389-0.173,0.389-0.389v-9.72C17.776,4.926,17.602,4.751,17.388,4.751 M16.448,5.53L10,11.984L3.552,5.53H16.448zM3.002,6.081l3.921,3.925l-3.921,3.925V6.081z M3.56,14.471l3.914-3.916l2.253,2.253c0.153,0.153,0.395,0.153,0.548,0l2.253-2.253l3.913,3.916H3.56z M16.999,13.931l-3.921-3.925l3.921-3.925V13.931z"></path>
    </svg>
    <mat-form-field>
            <mat-label>Email id</mat-label>
    <input matInput formControlName="email" class="email-input" required>
    <mat-error
    *ngIf="signUpFormGroup.controls.email.invalid && (signUpFormGroup.controls.email.dirty || signUpFormGroup.controls.email.touched) || signUpFormGroup.get('email').errors?.whitespace">
    {{getErrorMsgForAddFeedbackFormEmail()}}
    </mat-error>
</mat-form-field>
    </div>
    <div class="password">
    <svg class="svg-icon" viewBox="0 0 20 20">
    <path d="M17.308,7.564h-1.993c0-2.929-2.385-5.314-5.314-5.314S4.686,4.635,4.686,7.564H2.693c-0.244,0-0.443,0.2-0.443,0.443v9.3c0,0.243,0.199,0.442,0.443,0.442h14.615c0.243,0,0.442-0.199,0.442-0.442v-9.3C17.75,7.764,17.551,7.564,17.308,7.564 M10,3.136c2.442,0,4.43,1.986,4.43,4.428H5.571C5.571,5.122,7.558,3.136,10,3.136 M16.865,16.864H3.136V8.45h13.729V16.864z M10,10.664c-0.854,0-1.55,0.696-1.55,1.551c0,0.699,0.467,1.292,1.107,1.485v0.95c0,0.243,0.2,0.442,0.443,0.442s0.443-0.199,0.443-0.442V13.7c0.64-0.193,1.106-0.786,1.106-1.485C11.55,11.36,10.854,10.664,10,10.664 M10,12.878c-0.366,0-0.664-0.298-0.664-0.663c0-0.366,0.298-0.665,0.664-0.665c0.365,0,0.664,0.299,0.664,0.665C10.664,12.58,10.365,12.878,10,12.878"></path>
    </svg>
    <mat-form-field>
            <mat-label>Password</mat-label>
    <input matInput  type="password" id="password" formControlName="password" class="pass-input" minlength="4" maxlength="20" required showHideInput>
    <span class="material-icons eye-icon" showHideTrigger="password" [showHideStatus]="{ materialIcon: true, id: 'password' }"></span> 
    <mat-error
    *ngIf="signUpFormGroup.controls.password.invalid && (signUpFormGroup.controls.password.dirty || signUpFormGroup.controls.password.touched)">
    {{getErrorMsgForPassword()}}
    </mat-error>
</mat-form-field>
    </div>
    <div class="confirmPassword">
    <svg class="svg-icon" viewBox="0 0 20 20">
    <path d="M17.308,7.564h-1.993c0-2.929-2.385-5.314-5.314-5.314S4.686,4.635,4.686,7.564H2.693c-0.244,0-0.443,0.2-0.443,0.443v9.3c0,0.243,0.199,0.442,0.443,0.442h14.615c0.243,0,0.442-0.199,0.442-0.442v-9.3C17.75,7.764,17.551,7.564,17.308,7.564 M10,3.136c2.442,0,4.43,1.986,4.43,4.428H5.571C5.571,5.122,7.558,3.136,10,3.136 M16.865,16.864H3.136V8.45h13.729V16.864z M10,10.664c-0.854,0-1.55,0.696-1.55,1.551c0,0.699,0.467,1.292,1.107,1.485v0.95c0,0.243,0.2,0.442,0.443,0.442s0.443-0.199,0.443-0.442V13.7c0.64-0.193,1.106-0.786,1.106-1.485C11.55,11.36,10.854,10.664,10,10.664 M10,12.878c-0.366,0-0.664-0.298-0.664-0.663c0-0.366,0.298-0.665,0.664-0.665c0.365,0,0.664,0.299,0.664,0.665C10.664,12.58,10.365,12.878,10,12.878"></path>
    </svg>
    <mat-form-field>
            <mat-label>Confirm password</mat-label>
    <input matInput  type="password" id="confirmpassword" formControlName="confirmPassword" class="confirmPassword-input" showHideInput required>
    <span class="material-icons eye-icon" showHideTrigger="confirmpassword" [showHideStatus]="{ materialIcon: true, id: 'confirmpassword' }"></span> 
    <mat-error
    *ngIf="signUpFormGroup.controls.confirmPassword.invalid && (signUpFormGroup.controls.confirmPassword.dirty || signUpFormGroup.controls.confirmPassword.touched)">
    {{getErrorMsgForLoginFormconfirmPassword()}}
    </mat-error>
    </mat-form-field>
    </div>
    <div class="mobileNum">
    <svg class="svg-icon" viewBox="0 0 20 20">
    <path d="M13.372,1.781H6.628c-0.696,0-1.265,0.569-1.265,1.265v13.91c0,0.695,0.569,1.265,1.265,1.265h6.744c0.695,0,1.265-0.569,1.265-1.265V3.045C14.637,2.35,14.067,1.781,13.372,1.781 M13.794,16.955c0,0.228-0.194,0.421-0.422,0.421H6.628c-0.228,0-0.421-0.193-0.421-0.421v-0.843h7.587V16.955z M13.794,15.269H6.207V4.731h7.587V15.269z M13.794,3.888H6.207V3.045c0-0.228,0.194-0.421,0.421-0.421h6.744c0.228,0,0.422,0.194,0.422,0.421V3.888z"></path>
    </svg>
    <mat-form-field>
            <mat-label>Mobile Number</mat-label>
    <input matInput   formControlName="mobileNum" class="pass-input" minlength ="10" maxlength="10" required>
    <mat-error
    *ngIf="signUpFormGroup.controls.mobileNum.invalid && (signUpFormGroup.controls.mobileNum.dirty || signUpFormGroup.controls.mobileNum.touched) ">
    {{getErrorMsgForAddFeedbackMobileNumber()}}
    </mat-error> 
      </mat-form-field>
    </div>
    <button class="signin-button">Sign Up</button>
    </form>
    </div>
    <div class="link">Already have an account ? &nbsp;<a routerLink="/login">Sign in</a></div>
    </div>
    </section>
    <!-- End Of SignUp Page -->
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    <!-- Sign Up Form -->
    <!-- <mat-card class="back">
    <mat-card-content>
    <form [formGroup]="signUpFormGroup" class="example-form" (ngSubmit)="onSubmit()">
    <div class="head">
    <h3> Let's have a journey together ! </h3><br>
    <span>
    
    <h4>Please sign up to continue </h4>
    </span><br>
    </div><br>
    
    <div class="row">
    <div class="col-md-12">
    <div class="col-md-2">
    
    
    </div>
    <div class="col-md-4">
    <mat-form-field appearance="outline">
    <mat-label>First name </mat-label>
    <input matInput formControlName="firstName"placeholder="Enter Your First name"required>
    <mat-error
    *ngIf="signUpFormGroup.controls.firstName.invalid && (signUpFormGroup.controls.firstName.dirty || signUpFormGroup.controls.firstName.touched)">
    {{getErrorMsgForAddFeedbackFormfirstName()}}
    </mat-error>
    </mat-form-field>
    </div>
    <div class="col-md-4">
    <mat-form-field appearance="outline">
    <mat-label> Last name</mat-label>
    <input matInput formControlName="lastName" placeholder="Enter Your Last Name" required>
    <mat-error
    *ngIf="signUpFormGroup.controls.lastName.invalid && (signUpFormGroup.controls.lastName.dirty || signUpFormGroup.controls.lastName.touched) || signUpFormGroup.get('lastName').errors?.whitespace">
    {{getErrorMsgForAddFeedbackFormlastName()}}
    </mat-error>
    </mat-form-field>
    </div>
    <div class="col-md-2">
    
    </div>
    </div>
    </div>
    <div class="row">
    <div class="col-md-12">
    <div class="col-md-2">
    
    </div>
    <div class="col-md-4">
    <mat-form-field appearance="outline">
    <mat-label>Email </mat-label>
    <input matInput formControlName="email" placeholder="Enter Your Email Id" required>
    <mat-error
    *ngIf="signUpFormGroup.controls.email.invalid && (signUpFormGroup.controls.email.dirty || signUpFormGroup.controls.email.touched) || signUpFormGroup.get('email').errors?.whitespace">
    {{getErrorMsgForAddFeedbackFormEmail()}}
    </mat-error>
    </mat-form-field>
    </div>
    <div class="col-md-4">
    <mat-form-field appearance="outline">
    <mat-label>Mobile number</mat-label>
    <input matInput formControlName="mobileNum" placeholder="Enter Your Mobile Number" minlength ="10" maxlength="10" required>
    <mat-error
    *ngIf="signUpFormGroup.controls.mobileNum.invalid && (signUpFormGroup.controls.mobileNum.dirty || signUpFormGroup.controls.mobileNum.touched) ">
    {{getErrorMsgForAddFeedbackMobileNumber()}}
    </mat-error> 
    </mat-form-field>
    </div>
    
    <div class="col-md-2">
    
    </div>
    </div>
    </div>
    <div class="row">
    <div class="col-md-12">
    <div class="col-md-2">
    
    </div>
    <div class="col-md-4">
    <mat-form-field appearance="outline">
    <mat-label>Password</mat-label>
    <input type="password" minlength="4" maxlength="20" id="password" matInput formControlName="password" placeholder="Password" minlength="4" maxlength="20" required showHideInput>
    <i matSuffix class="material-icons" showHideTrigger="password" [showHideStatus]="{ materialIcon: true, id: 'password' }"></i>
    <mat-error
    *ngIf="signUpFormGroup.controls.password.invalid && (signUpFormGroup.controls.password.dirty || signUpFormGroup.controls.password.touched)">
    {{getErrorMsgForPassword()}}
    </mat-error>
    </mat-form-field>
    </div>
    <div class="col-md-4">
    <mat-form-field appearance="outline">
    <mat-label>Confirm password </mat-label>
    <input type="password" id="Confirmpassword" matInput formControlName="confirmPassword" placeholder="Confirm password" required showHideInput>
    <i matSuffix class="material-icons" showHideTrigger="Confirmpassword" [showHideStatus]="{ materialIcon: true, id: 'password' }"></i>
    <mat-error></mat-error>
    </mat-form-field>
    </div>
    
    <div class="col-md-2">
    
    </div>
    </div>
    </div>
    <br>
    <div class="row">
    <div class="col-md-3">
    </div>
    <div class="col-md-6">
    <button mat-raised-button color="primary">Sign up</button>
    </div>
    <div class="col-md-3">
    </div>
    </div>
    <br>
    <span> Already have an account ? </span> <a routerLink="/login">Login</a>
    </form>
    </mat-card-content>
    </mat-card> -->

































<!-- Sign Up Form 
<mat-card class="back">
    <mat-card-content>
        <form [formGroup]="signUpFormGroup" class="example-form" (ngSubmit)="onSubmit()">
            <div class="head">
                <h3> Let's have a journey together ! </h3><br>
                <span>
                    
                    <h4>Please sign up to continue </h4>
                </span><br>
            </div><br>

            <div class="row">
                <div class="col-md-12">
                    <div class="col-md-2">


                    </div>
                    <div class="col-md-4">
                        <mat-form-field appearance="outline">
                            <mat-label>First name </mat-label>
                            <input matInput formControlName="firstName"placeholder="Enter Your First name"required>
                            <mat-error
                        *ngIf="signUpFormGroup.controls.firstName.invalid && (signUpFormGroup.controls.firstName.dirty || signUpFormGroup.controls.firstName.touched)">
                        {{getErrorMsgForAddFeedbackFormfirstName()}}
                        </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-4">
                        <mat-form-field appearance="outline">
                            <mat-label> Last name</mat-label>
                            <input matInput formControlName="lastName" placeholder="Enter Your Last Name" required>
                        <mat-error
                        *ngIf="signUpFormGroup.controls.lastName.invalid && (signUpFormGroup.controls.lastName.dirty || signUpFormGroup.controls.lastName.touched) || signUpFormGroup.get('lastName').errors?.whitespace">
                        {{getErrorMsgForAddFeedbackFormlastName()}}
                      </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-2">

                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="col-md-2">

                    </div>
                    <div class="col-md-4">
                        <mat-form-field appearance="outline">
                            <mat-label>Email </mat-label>
                           <input matInput formControlName="email" placeholder="Enter Your Email Id" required>
                            <mat-error
                            *ngIf="signUpFormGroup.controls.email.invalid && (signUpFormGroup.controls.email.dirty || signUpFormGroup.controls.email.touched) || signUpFormGroup.get('email').errors?.whitespace">
                            {{getErrorMsgForAddFeedbackFormEmail()}}
                          </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-4">
                        <mat-form-field appearance="outline">
                            <mat-label>Mobile number</mat-label>
                            <input matInput formControlName="mobileNum" placeholder="Enter Your Mobile Number" minlength ="10" maxlength="10" required>
                        <mat-error
            *ngIf="signUpFormGroup.controls.mobileNum.invalid && (signUpFormGroup.controls.mobileNum.dirty || signUpFormGroup.controls.mobileNum.touched) ">
            {{getErrorMsgForAddFeedbackMobileNumber()}}
          </mat-error> 
                        </mat-form-field>
                    </div>

                    <div class="col-md-2">

                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="col-md-2">

                    </div>
                    <div class="col-md-4">
                        <mat-form-field appearance="outline">
                            <mat-label>Password</mat-label>
                             <input type="password"  minlength="4" maxlength="20" id="password" matInput formControlName="password" placeholder="Password"  minlength="4" maxlength="20" required showHideInput>
                            <i matSuffix class="material-icons" showHideTrigger="password" [showHideStatus]="{ materialIcon: true, id: 'password' }"></i>
                            <mat-error
                            *ngIf="signUpFormGroup.controls.password.invalid && (signUpFormGroup.controls.password.dirty || signUpFormGroup.controls.password.touched)">
                            {{getErrorMsgForPassword()}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-4">
                        <mat-form-field appearance="outline">
                            <mat-label>Confirm password </mat-label>
                         <input type="password" id="Confirmpassword" matInput formControlName="confirmPassword" placeholder="Confirm password" required showHideInput>
                            <i matSuffix class="material-icons" showHideTrigger="Confirmpassword" [showHideStatus]="{ materialIcon: true, id: 'password' }"></i>
                            <mat-error></mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-2">

                    </div>
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col-md-3">
                </div>
                <div class="col-md-6">
                    <button mat-raised-button color="primary">Sign up</button>
                </div>
                <div class="col-md-3">
                </div>
            </div>
            <br>
            <span> Already have an account ? </span> <a routerLink="/login">Login</a>
        </form>
    </mat-card-content>
</mat-card> -->